<div class="tab-content" [class.active]="active()" [class.disabled]="disabled()">
  <ng-content />
</div>
